import {FontWeights, INavStyles, IStackStyles, mergeStyleSets} from "@fluentui/react"
import {Theme} from "@fluentui/react-theme-provider"

export const nonShrinkingStackItemStyles: IStackStyles = {
    root: {

        padding: 12,
        overflow: 'hidden',
        alignItems: "center",
    }
}

export const navStyles: Partial<INavStyles> = {
    link: {
        whiteSpace: 'normal',
        lineHeight: 'inherit'
    }
}

export const iconButtonStyles = {
    root: {
        marginLeft: 'auto',
        marginTop: '4px',
        marginRight: '2px',
    }
}

export interface IContentStyles {
    newContainer: string
    addContainer: string
}

export const contentStyles = (theme: Theme): IContentStyles => {

    return mergeStyleSets({
        newContainer: {
            borderTop: `4px solid ${theme.palette.themePrimary}`,
            display: 'flex',
            height: "90vh",
            minWidth: '320px',
            overflow: "hidden",
            width: '65vw'
        },
        addContainer: {
            borderTop: `4px solid ${theme.palette.themePrimary}`,
            display: 'flex',
            minHeight: "320px",
            height: "360px",
            minWidth: '320px',
            overflow: "hidden",
            maxWidth: '720px',
            width: '720px'
        }
    })
}
